interface ContentItem {
  id: string;
  category: string;
  tag: string;
  title: string;
  excerpt: string;
  cover: string;
  readCount: string;
  date: string;
  hot?: number;
}

interface ContentCardProps {
  item: ContentItem;
  onCategorySelect?: (category: string) => void;
}

export default function ContentCard({ item, onCategorySelect }: ContentCardProps) {
  return (
    <article className="group flex flex-col h-full rounded-card border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300">
      <div className="relative w-full aspect-[10/7] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} - ${item.category}相关内容配图`}
          title={`${item.title} ${item.category}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-background-50/92 px-2.5 py-1 text-[11px] font-medium text-primary-700 backdrop-blur">
          <i className="ri-price-tag-3-line"></i>
          {item.tag}
        </span>
      </div>

      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 text-[11px] md:text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 text-accent-700">
            <i className="ri-folder-3-line"></i>
            {item.category}
          </span>
          <span className="w-px h-3 bg-background-300"></span>
          <span>{item.date}</span>
        </div>

        <h3 className="mt-2.5 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2">
          {item.title}
        </h3>

        <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
          {item.excerpt}
        </p>

        <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between">
          <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-eye-line"></i>
            {item.readCount} 阅读
          </span>
          {onCategorySelect ? (
            <button
              type="button"
              onClick={() => onCategorySelect(item.category)}
              className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-primary-600 cursor-pointer transition-colors hover:text-primary-700"
              aria-label={`查看「${item.category}」分区的更多内容`}
            >
              看这一类
              <i className="ri-arrow-right-line"></i>
            </button>
          ) : (
            <span className="inline-flex items-center gap-1 text-xs md:text-sm font-medium text-primary-600">
              看这一类
              <i className="ri-arrow-right-line"></i>
            </span>
          )}
        </div>
      </div>
    </article>
  );
}